(function () {
  const SCROLL_DURATION_MS = 900; // slower scroll
  const EXTRA_TOP_OFFSET_PX = 24; // extra spacing from the top

  function getTopOffset() {
    const header =
      document.querySelector('.section-header') ||
      document.querySelector('.shopify-section-header-sticky') ||
      document.querySelector('.header-wrapper');
    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    return headerHeight + EXTRA_TOP_OFFSET_PX;
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function smoothScrollTo(y, duration) {
    const startY = window.pageYOffset;
    const distance = y - startY;
    const startTime = performance.now();

    function step(now) {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeInOutCubic(progress);
      window.scrollTo(0, startY + distance * eased);
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  // Delegated handler for hash links
  document.addEventListener('click', function (event) {
    const anchor = event.target.closest('a[href^="#"]');
    if (!anchor) return;

    // Opt-out if needed
    if (anchor.hasAttribute('data-no-hash-handler')) return;

    const href = anchor.getAttribute('href');
    if (!href) return;

    // Prevent default for placeholder links
    if (href === '#') {
      event.preventDefault();
      return;
    }

    const hash = href.trim();
    if (hash.length <= 1) {
      event.preventDefault();
      return;
    }

    const id = decodeURIComponent(hash.slice(1));
    const target = document.getElementById(id) || document.querySelector('[name="' + id.replace(/"/g, '\\"') + '"]');

    if (!target) return;

    event.preventDefault();

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Compute target Y with offset
    const offset = getTopOffset();
    const rect = target.getBoundingClientRect();
    const startY = window.pageYOffset;
    const destination = Math.min(
      Math.max(rect.top + startY - offset, 0),
      document.documentElement.scrollHeight - window.innerHeight
    );

    if (prefersReducedMotion) {
      window.scrollTo(0, destination);
    } else {
      smoothScrollTo(destination, SCROLL_DURATION_MS);
    }

    if (history.pushState) {
      history.pushState(null, '', hash);
    } else {
      location.hash = hash;
    }

    // Ensure focus for accessibility without re-scrolling
    const previousTabIndex = target.getAttribute('tabindex');
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    if (previousTabIndex !== null) {
      target.setAttribute('tabindex', previousTabIndex);
    } else {
      target.removeAttribute('tabindex');
    }
  });
})();


